import React from 'react';
import SidebarParametres from '../../../layout/SidebarParametres';
import { useOAD } from '../../../layout/OADLayout';
import { api } from '../../shared/api/api';
import { useApiData } from '../../shared/hooks/useFetch';
import LimiteErreur from '../../shared/components/LimiteErreur';
import ParametresEau3Mois, { useParametresPourApi } from '../../shared/components/ParametresEau3Mois';
import { SousTitreSysteme, NotesSysteme } from '../../shared/components/Eau3MoisTextes';
import Eau3MoisBandesChart from '../../shared/charts/Eau3MoisBandesChart';
import { libelleGrandeur, formatJJMMAAAA } from '../../shared/utils/eau3mois';

/**
 * Eau à 3 mois / Besoin journalier — port de l'onglet "Besoin journalier" de
 * l'app Shiny : enveloppe des trajectoires du besoin unitaire (mm/jour pour
 * une culture, L/tête/jour pour un animal), partie observée et réalisé SAFRAN.
 */
export default function Unitaire() {
  const { idExploit } = useOAD();
  const { pret, parametres } = useParametresPourApi({ grandeurDefaut: 'culture' });
  const { data, loading, error } = useApiData(api.getEau3MoisJournalier, parametres, { skip: !pret });

  return (
    <div className="oad-contenu">
      <SidebarParametres niveau1="annee-en-cours" niveau2="eau-3-mois" niveau3="unitaire" idExploit={idExploit}>
        <ParametresEau3Mois avecProduction grandeurDefaut="culture" />
      </SidebarParametres>
      <main className="oad-cards">
        <section className="oad-card">
          <h2 className="tdb-section-titre">
            {libelleGrandeur(parametres.type, parametres.grandeur)} — pas journalier
          </h2>
          {error && <p className="tdb-erreur">{error}</p>}
          {loading && <p className="tdb-chargement">Chargement…</p>}
          {data && (
            <>
              <SousTitreSysteme info={data.info} coupure={data.coupure} rcp={parametres.rcp} />
              <LimiteErreur cle={`jour-${JSON.stringify(parametres)}`}>
                <Eau3MoisBandesChart
                  origine={data.origine} bandes={data.bandes} nObs={data.nObs}
                  realise={data.realise} coupure={data.coupure} unite={data.info.unite} decimales={2}
                />
              </LimiteErreur>
              <p style={{ fontSize: 13, color: '#555' }}>
                {data.info.unite.includes('m³') ? '' : `Moyenne pondérée par les ${data.info.uniteQuantite === 'ha' ? 'surfaces' : 'effectifs'} du territoire. `}
                {data.realise && `Réalisé SAFRAN observé jusqu'au ${formatJJMMAAAA(data.realise.coupure)}.`}
              </p>
              <NotesSysteme info={data.info} grandeur={parametres.grandeur} />
            </>
          )}
        </section>
      </main>
    </div>
  );
}
